import { getId } from '@common/utils/brandDiffsUtils';
import { StoreLocatorActionTypes } from '@state/features/common.types';
import analytics from '@utils/analytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const GeoOptions = {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 0,
};
const StoreLocatorGeo = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const successLocalization = (pos) => {
        let crd = pos.coords;
        console.log('Your current position is:');
        console.log(`Latitude : ${crd.latitude}`);
        console.log(`Longitude: ${crd.longitude}`);
        console.log(`More or less ${crd.accuracy} meters.`);
        dispatch({ type: StoreLocatorActionTypes.USE_LOCATION, payload: { lat: pos.coords.latitude, lng: pos.coords.longitude } });
    };
    const errorLocalization = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    return (React.createElement("button", { type: "button", className: "use-location", "aria-label": t('storelocator.usemylocation'), onClick: (e) => {
            if (navigator.geolocation) {
                analytics.storelocatorMyLocation();
                navigator.geolocation.getCurrentPosition(successLocalization, errorLocalization, GeoOptions);
            }
            else {
                console.warn('Geolocation is not supported by this browser.');
            }
        } }, getId() === 'ST' && React.createElement("span", null, t('storelocator.usemylocation'))));
};
export default StoreLocatorGeo;
